




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { PaycheckForm } from './PaycheckForm';
import formatDateTime from '@/filters/formatDateTime';

@Component
export default class PaycheckTimestamps extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm

  private formatDateTime = formatDateTime;
}
